import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PROFILES } from "../data/catalog";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative">
      {/* Hero */}
      <section className="relative max-w-7xl mx-auto px-6 pt-20 pb-24">
        <div className="text-xs tracking-[0.3em] uppercase text-white/50 mb-6" data-testid="hero-eyebrow">
          Bureau de dessin — BTP · Architecture · BIM
        </div>
        <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter leading-[0.95] max-w-5xl">
          Des plans précis,<br />
          <span className="text-white/50">accompagnement technique</span><br />
          pour vos projets BTP.
        </h1>
        <p className="mt-8 text-white/60 max-w-xl leading-relaxed">
          Exécution, coffrage, DOE, rendus 3D, modélisation BIM… choisissez votre profil
          ci-dessous pour découvrir les services adaptés et bâtir votre devis en quelques clics.
        </p>
      </section>

      {/* Bento grid des profils */}
      <section className="max-w-7xl mx-auto px-6 pb-28" data-testid="profiles-section">
        <div className="flex items-end justify-between border-b border-[#1E2D4A] pb-4 mb-8">
          <div>
            <div className="text-xs tracking-[0.3em] uppercase text-white/40">01 — Profils</div>
            <h2 className="font-heading text-3xl sm:text-4xl tracking-tight mt-2">Vous êtes…</h2>
          </div>
          <div className="text-sm text-white/40 hidden sm:block">8 profils disponibles</div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {PROFILES.map((p, idx) => (
            <Link
              key={p.id}
              to={`/profil/${p.id}`}
              data-testid={`profile-card-${p.id}`}
              className="group relative aspect-[4/5] overflow-hidden border border-[#1E2D4A] bg-[#0A1326] hover:border-white/60 transition-all duration-500"
              style={{ animationDelay: `${idx * 60}ms` }}
            >
              <img
                src={p.image}
                alt={p.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-55 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#040914] via-[#040914]/60 to-[#040914]/10" />
              <div className="relative h-full flex flex-col justify-between p-5">
                <div className="flex items-start justify-end">
                  <ArrowUpRight
                    className="w-5 h-5 text-white/70 group-hover:text-white group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
                    strokeWidth={1.5}
                  />
                </div>
                <div>
                  <h3 className="font-heading text-xl lg:text-2xl tracking-tight text-white">
                    {p.title}
                  </h3>
                  <p className="text-sm text-white/60 mt-1">{p.subtitle}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
